const NotFound = () => {
    return (
        <div className="text-center p-4">
            Not Found
        </div>
    )
};

export default NotFound;